module.exports = __webpack_public_path__ + "static/media/slide2.3511c62b.jpg";